export const translations = {
  en: {
    startScreen: {
      subtitle: "3D Immersive Experience",
      title: "The best training door for emergency services",
      text: "Whether fire brigade, armed forces, THW or special units, with the training door from Switchboombang, emergency services train the most diverse forced entry techniques closer to reality than ever before!",
      buttonLoading: "Loading",
      buttonResume: "Resume",
      buttonStart: "Explore",
    },
    welcomeInstructions: {
      title: "Navigation instructions",
      desktop: {
        rotate: {
          alt: "Rotate",
          title: "Camera 360 rotation",
          descriptionMouse: "Linksklick (Maus)",
          descriptionTrackpad: "Swipe (Trackpad)",
        },
        zoom: {
          alt: "Zoom",
          title: "Camera zoom",
          descriptionMouse: "Wheel scroll (Mouse)",
          descriptionTrackpad: "Pinch (Trackpad)",
        },
        cameraPan: {
          alt: "Camera Pan",
          title: "Camera pan",
          descriptionMouse: "Middle button click + move (Mouse)",
        },
      },
      mobile: {
        rotate: {
          alt: "Rotate",
          title: "Camera 360 rotation",
          descriptionMouse: "",
          descriptionTrackpad: "Swipe to rotate",
        },
        zoom: {
          alt: "Zoom",
          title: "Camera zoom",
          descriptionMouse: "",
          descriptionTrackpad: "Pinch to zoom",
        },
      },
    },
    contactPopUp: {
      button: "Technical Data & Contact",
      techData: {
        title: "Technical data",
        text: "The practice door consists of the door leaf, door frame, and base plate. If needed, the practice door can be easily disassembled into its components and stored to save space.",
        table: {
          header1: "Component",
          header2: "Dimensions (WxHxD) in cm",
          header3: "Weight",
          rowName1: "Door leaf",
          rowName2: "Door frame",
          rowName3: "Base plate",
        },
      },
      share: {
        title: "Your door configuration is ready to share with others.",
        copyText: "Copy the link to your clipboard or share it directly.",
        buttonLink: "Copy configuration link",
        buttonLinkSuccess: "Link Copied!",
        buttonShare: "Share",
        widget: {
          title: "My Switchboombang Configuration",
          text: "Check out my Switchboombang configuration!",
        },
      },
      contact: {
        title: "Feel free to write to us!",
        text: "Do you have questions? We have answers!",
        buttonLink: "Contact us",
      },
    },
  },
  de: {
    startScreen: {
      subtitle: "3D Immersive Erfahrung",
      title: "Die beste Übungstür für Einsatzkräfte",
      text: "Ob Feuerwehr, Bundeswehr, THW oder Spezialeinheiten, mit der Übungstür von Switchboombang trainieren Einsatzkräfte die unterschiedlichsten Forcible Entry Techniken so nahe an der Realität wie nie zuvor!",
      buttonLoading: "Wird geladen",
      buttonResume: "Fortsetzen",
      buttonStart: "Erkunden",
    },
    welcomeInstructions: {
      title: "Navigationsanweisungen",
      desktop: {
        rotate: {
          alt: "Drehen",
          title: "360 Kamera Rotation",
          descriptionMouse: "Linksklick (Maus)",
          descriptionTrackpad: "Wischen (Trackpad)",
        },
        zoom: {
          alt: "Zoom",
          title: "Kamera Zoom",
          descriptionMouse: "Scrollrad (Maus))",
          descriptionTrackpad: "Ziehen/Pinchen (Trackpad)",
        },
        cameraPan: {
          alt: "Kamera Verschieben",
          title: "Kamera Verschieben",
          descriptionMouse: "Mittlere Taste klicken und bewegen (Maus)",
        },
      },
      mobile: {
        rotate: {
          alt: "Drehen",
          title: "360 Kamera Rotation",
          descriptionMouse: "",
          descriptionTrackpad: "Wischen zum Drehen",
        },
        zoom: {
          alt: "Zoom",
          title: "Kamera Zoom",
          descriptionMouse: "",
          descriptionTrackpad: "Pinchen zum Zoomen",
        },
      },
    },
    contactPopUp: {
      button: "Technische Daten & Kontakt",
      techData: {
        title: "Technische Daten",
        text: "Die Übungstür besteht aus den Komponenten Türblatt, Türrahmen und Bodenplatte. Bei Bedarf lässt sich die Übungstür leicht in ihre Komponenten zerlegen und platzsparend verstauen.",
        table: {
          header1: "Komponente",
          header2: "Maße (BxHxT) in cm",
          header3: "Gewicht",
          rowName1: "Türblatt",
          rowName2: "Türrahmen",
          rowName3: "Bodenplatte",
        },
      },
      share: {
        title: "Deine Türkonfiguration ist bereit zum Teilen.",
        copyText:
          "Kopiere den Link in die Zwischenablage oder teile ihn direkt.",
        buttonLink: "Konfigurationslink kopieren",
        buttonLinkSuccess: "Link kopiert!",
        buttonShare: "Teilen",
        widget: {
          title: "Meine Switchboombang Konfiguration",
          text: "Schau dir meine Switchboombang Konfiguration an!",
        },
      },
      contact: {
        title: "Schreiben Sie uns gerne!",
        text: "Sie haben Fragen? Wir haben Antworten!",
        buttonLink: "Kontakt aufnehmen",
      },
    },
  },
};
